export { default } from './useMyDegrees';
export { default as useMyDegrees } from './useMyDegrees';
